import React, { useEffect } from 'react';
import { logout } from '../services/auth.api';

const Logout: React.FC = () => {
  useEffect(() => {
    if(localStorage.getItem('access_token')){
        logout();
    }
    else{
        window.location.href = process.env.REACT_APP_BASE_URL || ''
    }
  }, []);

  return null; 
};

export default Logout;
